import React from 'react';
import Checkbox from '@mui/material/Checkbox';
import { Field, change } from 'redux-form';
import store from './../../../../store';

const renderCheckbox = ({ input, meta, ...custom }) => (
    <Checkbox {...input} {...custom} checked={!!input.value} inputProps={{ name: input.name }} />
);

export default ({ code, id }) => (
    <Field
        name={JSON.stringify({ code, id })}
        onChange={() => {
            store.dispatch(change('from-tableComponent', JSON.stringify({ code: 'tag', id }), ''));
        }}
        component={renderCheckbox}
    />
);
